import { useNavigate } from 'react-router-dom';
import { Download, Plus, Layers } from 'lucide-react';
import { AuthButton } from '@/core/permissions/AuthButton';
import { DataFilterToolbar, type FilterDefinition } from '@/components/ui/DataFilterToolbar';
import type { AgroProductFilters } from '../types/agroProductList.types';

interface AgroProductToolbarProps {
  filters: AgroProductFilters;
  onSearchChange: (search: string) => void;
  onStatusChange: (status: string) => void;
  onFilterChange?: (key: string, value: string) => void;
  filterOptions?: {
    groups?: { label: string; value: string }[];
  };
}

export function AgroProductToolbar({
  filters,
  onSearchChange,
  onStatusChange,
  onFilterChange,
  filterOptions = { groups: [] },
}: AgroProductToolbarProps) {
  const navigate = useNavigate();

  const filterDefs: FilterDefinition[] = [
    {
      id: 'groupId',
      label: 'Tất cả nhóm vật tư',
      options: filterOptions.groups || [],
    },
    {
      id: 'status',
      label: 'Tất cả trạng thái',
      options: [
        { label: 'Hoạt động', value: 'active' },
        { label: 'Không hoạt động', value: 'inactive' },
        { label: 'Hết hàng', value: 'out_of_stock' },
        { label: 'Hết hạn', value: 'expired' },
      ]
    }
  ];

  const handleFilterChange = (key: string, value: string) => {
    if (key === 'status') {
      onStatusChange(value || 'all');
    } else if (onFilterChange) {
      onFilterChange(key, value);
    }
  };

  const actions = (
    <>
      <button
        onClick={() => navigate('/agro/categories')}
        className="h-9 sm:text-sm text-xs border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 shrink-0 rounded-md px-3 flex items-center transition-colors font-medium"
      >
        <Layers className="w-4 h-4 mr-2" />
        Nhóm vật tư
      </button>
      <AuthButton
        module="agro"
        action="create"
        behavior="hide"
        variant="outline"
        className="h-9 sm:text-sm text-xs border-slate-200 shrink-0"
      >
        <Download className="w-4 h-4 mr-2" />
        Nhập vật tư
      </AuthButton>
      <AuthButton
        module="agro"
        action="create"
        behavior="disable"
        permissionReason="Bạn không có quyền thêm vật tư mới"
        className="bg-emerald-600 hover:bg-emerald-700 text-white border-none h-9 sm:text-sm text-xs shrink-0 rounded-md px-3 flex items-center"
        onClick={() => navigate('/agro/new')}
      >
        <Plus className="w-4 h-4 mr-2" />
        Thêm vật tư
      </AuthButton>
    </>
  );

  return (
    <DataFilterToolbar
      search={filters.search || ''}
      onSearchChange={onSearchChange}
      searchPlaceholder="Tìm kiếm theo tên, mã vật tư..."
      filterDefs={filterDefs}
      filterValues={{ ...filters, status: filters.status === 'all' ? '' : filters.status }}
      onFilterChange={handleFilterChange}
      actions={actions}
    />
  );
}
